import {Injector, NgModule} from '@angular/core';
import {createCustomElement} from '@angular/elements';
import {HttpHeaders, HttpClientModule} from '@angular/common/http';
import {OverlayModule} from '@angular/cdk/overlay';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import {AiChatComponent} from './ai-chat-component/ai-chat.component';
import {ChatComponent} from './cyn/chat-module/components/chat/chat.component';
import {UI_KIT_ICONS} from './ui-kit-icons.providers';
import {GoodBaseBatchService} from './custom/goodbase/goodbase-batch.service';
import {GOODBASE_FORM} from './cyn/fck-chat-module/core/forms/ai-form-catalog';
import {AgentFormService} from './services/agent-form.service';

@NgModule({
  declarations: [AiChatComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    OverlayModule,
    HttpClientModule,
    RouterModule.forRoot([]),
    ChatComponent,
  ],
  providers: [...UI_KIT_ICONS],
  entryComponents: [AiChatComponent],
})
export class AiChatModule {
  public static readonly NO_CACHE_HEADERS = new HttpHeaders({
    'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
    'Pragma': 'no-cache',
    'Expires': '0',
  });

  constructor(private injector: Injector) {}

  ngDoBootstrap(): void {
    this.injector.get(AgentFormService).registerOpener(GOODBASE_FORM.id,
      () => this.injector.get(GoodBaseBatchService).open([], false));
    document.querySelectorAll('ai-chat').forEach((node) => {
      node.setAttribute('ng-non-bindable', '');
    });
    const el = createCustomElement(AiChatComponent, {injector: this.injector});
    customElements.define('ai-chat', el);
  }
}
